import { createApp } from 'vue'
import App from './App.vue'
import smoothscroll from 'smoothscroll-polyfill';
import Particles from "particles.vue3";

createApp(App).use(Particles).mount('#portfolio');

smoothscroll.polyfill();